/* eslint-disable import/first */
import React from 'react';

export default function FutureClock(props) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 11C22 10.8664 21.9976 10.7332 21.9929 10.6008C21.7827 4.71058 16.9415 0 11 0C5.0585 0 0.21725 4.71058 0.00713281 10.6008C0.00240625 10.7332 0 10.8664 0 11C0 17.0751 5.65048 21.6008 11 21.6008C16.4465 21.6008 22 17.0751 22 11Z"
        fill="#FF5876"
      />
      <path
        d="M11 21.2019C5.05858 21.2019 0.218195 16.4912 0.00799219 10.6011C0.00322266 10.7337 0 10.8666 0 11.0003C0 17.0754 4.92486 22.0003 11 22.0003C17.0751 22.0003 22 17.0754 22 11.0003C22 10.8666 21.9968 10.7337 21.9921 10.6011C21.7818 16.4912 16.9414 21.2019 11 21.2019Z"
        fill="#E6485D"
      />
      <path
        d="M20.1704 10.601C19.9614 5.71684 15.9356 1.82129 11 1.82129C6.06441 1.82129 2.03867 5.71684 1.82967 10.601C1.824 10.7334 1.82963 19.5952 11 19.5952C20.1704 19.5952 20.176 10.7334 20.1704 10.601Z"
        fill="#E4EEF9"
      />
      <path
        d="M11 19.3808C6.06444 19.3808 2.03934 15.4852 1.83026 10.6011C1.82459 10.7335 1.82111 10.8664 1.82111 11.0003C1.82111 16.0696 5.93064 20.1792 11 20.1792C16.0694 20.1792 20.1789 16.0697 20.1789 11.0003C20.1789 10.8665 20.1754 10.7335 20.1698 10.6011C19.9607 15.4852 15.9356 19.3808 11 19.3808Z"
        fill="#D5E0F2"
      />
      <path
        d="M14.3341 7.77759C14.0725 7.51956 13.6512 7.52244 13.3933 7.78403L11.832 9.36687L11.9889 10.1204L12.7182 10.3634L14.3406 8.71848C14.5986 8.45688 14.5957 8.03562 14.3341 7.77759Z"
        fill="#405B6C"
      />
      <path
        d="M10.0582 9.42938L6.51749 6.2741C6.24314 6.0296 5.8226 6.05384 5.57816 6.32819C5.33371 6.60251 5.3579 7.02308 5.63225 7.26753L9.2427 10.4849L9.99504 10.234L10.0582 9.42938Z"
        fill="#405B6C"
      />
      <path
        d="M15.7109 15.291C15.6354 15.291 15.5595 15.2654 15.4971 15.213L11.283 11.6733C11.1424 11.5552 11.1241 11.3453 11.2422 11.2047C11.3604 11.064 11.5702 11.0457 11.7109 11.1639L15.925 14.7036C16.0656 14.8218 16.0839 15.0317 15.9658 15.1723C15.9 15.2506 15.8058 15.291 15.7109 15.291Z"
        fill="#86DCFF"
      />
      <path
        d="M9.24271 10.4848L9.86403 11.0385L10.662 10.7673L10.6187 9.92863L10.0583 9.4292C9.66831 9.66351 9.37316 10.0389 9.24271 10.4848Z"
        fill="#2D4456"
      />
      <path
        d="M11.832 9.36719L11.3037 9.90275V10.954H12.1358L12.7182 10.3637C12.5581 9.93072 12.239 9.57524 11.832 9.36719Z"
        fill="#2D4456"
      />
      <path
        d="M12.0649 10.6005C11.9032 10.1695 11.4874 9.86279 11 9.86279C10.5126 9.86279 10.0968 10.1695 9.9351 10.6005C9.88853 10.7247 9.93201 11.7376 11 11.7376C12.068 11.7376 12.1115 10.7247 12.0649 10.6005Z"
        fill="#FF5876"
      />
      <path
        d="M11 11.3388C10.5126 11.3388 10.0969 11.0321 9.93528 10.6011C9.88866 10.7253 9.86301 10.8597 9.86301 11.0003C9.86301 11.6282 10.3721 12.1372 11 12.1372C11.6279 12.1372 12.1369 11.6282 12.1369 11.0003C12.1369 10.8597 12.1113 10.7253 12.0647 10.6011C11.9031 11.032 11.4874 11.3388 11 11.3388Z"
        fill="#E6485D"
      />
      <path
        d="M11.3333 4.01806V2.98565C11.3333 2.80157 11.1841 2.65234 11 2.65234C10.8159 2.65234 10.6667 2.80157 10.6667 2.98565V4.01806C10.6667 4.20214 10.8159 4.35137 11 4.35137C11.1841 4.35137 11.3333 4.20214 11.3333 4.01806Z"
        fill="#405B6C"
      />
      <path
        d="M10.6667 17.9778V19.0102C10.6667 19.1943 10.8159 19.3436 11.0001 19.3436C11.1842 19.3436 11.3334 19.1943 11.3334 19.0102V17.9778C11.3334 17.7938 11.1841 17.6445 11.0001 17.6445C10.816 17.6445 10.6667 17.7938 10.6667 17.9778Z"
        fill="#405B6C"
      />
      <path
        d="M19.0117 11.3307C19.1959 11.3307 19.3451 11.1814 19.3451 10.9974C19.3451 10.8133 19.1958 10.6641 19.0117 10.6641H17.9793C17.7953 10.6641 17.646 10.8133 17.646 10.9974C17.646 11.1814 17.7953 11.3307 17.9793 11.3307H19.0117Z"
        fill="#405B6C"
      />
      <path
        d="M2.98834 10.6641C2.80422 10.6641 2.65503 10.8133 2.65503 10.9974C2.65503 11.1814 2.80422 11.3307 2.98834 11.3307H4.02075C4.20487 11.3307 4.35406 11.1814 4.35406 10.9974C4.35406 10.8133 4.20483 10.6641 4.02075 10.6641H2.98834Z"
        fill="#405B6C"
      />
    </svg>
  );
}
